import { create } from 'zustand';

import type { LogAccessProfile } from './logAccess.types';

// Authenticated content mounts only after the boundary verifies and publishes this profile.
// This state is never persisted; server authorization remains authoritative.
export const useLogAccess = create<LogAccessProfile>(() => ({
	restricted: false,
}));

// Non-React clients read the same current, non-persisted profile.
export const getLogAccessProfile = useLogAccess.getState;
